import jwt_decode from "jwt-decode";
import { createContext, useCallback, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";

export const AppContext = createContext<any>({});

const AppContextContainer = ({ children }: { children: any }) => {
    const [user, setUser] = useState<any>()
    const [branch, setBranch] = useState<any>()
    const token = localStorage.getItem('token')
    const [loading, setLoading] = useState(true)
    let navigate = useNavigate()
    const history = useLocation()

    let authCheck = useCallback(async () => {
        try {
            if (token) {
                const decodedToken: any = jwt_decode(token);

                if (decodedToken?.userId) {
                    setUser(decodedToken)
                    setLoading(false);
                } else {
                    setLoading(false)
                    localStorage.removeItem('token');
                    navigate("/login");
                }
            } else {
                setLoading(false)
                localStorage.removeItem('token');
                navigate("/login");
            }
        } catch (err) {
            setLoading(false)
            localStorage.removeItem('token');
            navigate("/login");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, history.pathname]);

    useEffect(() => {
        authCheck();
    }, [authCheck]);

    useEffect(() => {
        if (history.pathname) {
            window.scroll({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [history.pathname])

    return loading ?
        <div className="preloader" >
            <div className="spinner" ></div >
        </div > : <AppContext.Provider value={{ user, setUser, branch, setBranch }}>
            {children}
        </AppContext.Provider>;
}

export default AppContextContainer;